export enum TransportMethod {
    BOAT = 'boat',
    PLANE = 'plane',
    TRAIN = 'train',
    TRUCK = 'truck'
}